module.exports = __webpack_public_path__ + "Icono_CotizarProducto_256px.png";